import { Component, OnInit, Input, Optional, ViewChild, ContentChild, ElementRef } from '@angular/core';
import { NgControl, NgForm, ValidationErrors } from '@angular/forms';
import { TranslatorService } from '../../common/localization/lang/translator.service';
import { RequiredFieldDirective } from './required.directive';

@Component({
  selector: 'mcb-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.css'],
  // tslint:disable-next-line: use-host-property-decorator
  host: {
    '[class]': '"mcb-form-control"'
  }
})
export class FormControlComponent implements OnInit {
  @Input() label: string;
  @Input() labelKey: string | { key: string, subsystem: string };
  @Input() hint: string;
  @Input() hintKey: string | { key: string, subsystem: string };
  @Input() showMessages = true;
  @Input() showValidationErrors = true;
  @ContentChild(NgControl, { static: true }) private ngCtrl: NgControl;
  @ContentChild(NgControl, { static: true, read: ElementRef }) private ngCtrlElm: ElementRef;
  @ContentChild(RequiredFieldDirective, { static: true }) private requiredDirective: RequiredFieldDirective;
  private _firstErrorReported: boolean;

  constructor(
    private trans: TranslatorService,
    @Optional() private form: NgForm
  ) {
  }

  ngOnInit() {
  }

  get labelText() {
    let label;
    if (typeof this.label === 'string') {
      label = this.label;
    } else if (typeof this.labelKey === 'string') {
      label = this.trans.instant(this.labelKey);
    } else if (typeof this.labelKey === 'object') {
      const { key, subsystem } = this.labelKey;
      label = this.trans.instant(key, subsystem);
    }

    return label;
  }

  get hintText() {
    let hint;
    if (typeof this.hint === 'string') {
      hint = this.hint;
    } else if (typeof this.hintKey === 'string') {
      hint = this.trans.instant(this.hintKey);
    } else if (typeof this.hintKey === 'object') {
      const { key, subsystem } = this.hintKey;
      hint = this.trans.instant(key, subsystem);
    }

    return hint;
  }

  get errorText() {
    let error;
    if (this.ngCtrl && this.ngCtrl.errors && (this.ngCtrl.touched || (this.form && this.form.submitted))) {
      this._firstErrorReported = true;
      error = this.localizeError(this.ngCtrl.errors);
    }

    return error;
  }

  get required() {
    // if (!this.ngCtrl) {
    //   return false;
    // }

    // return this.ngCtrlElm.nativeElement.required;
    return this.requiredDirective && this.requiredDirective.value !== false;
  }

  localizeError(err: ValidationErrors) {
    let text: string;
    if (err.required) {
      text = this.trans.instant('validation-err-required');
    } else if (err.min) {
      text = this.trans.instant('validation-err-min').replace('{0}', err.min.requiredMin);
    } else if (err.max) {
      text = this.trans.instant('validation-err-max').replace('{0}', err.max.requiredMax);
    } else if (err.minlength) {
      text = this.trans.instant('validation-err-minlength').replace('{0}', err.minlength.requiredLength);
    } else if (err.maxlength) {
      text = this.trans.instant('validation-err-maxlength').replace('{0}', err.maxlength.requiredLength);
    } else if (err.email) {
      text = this.trans.instant('validation-err-email');
    } else if (err.nationalCodeValidator) {
      text = this.trans.instant('validation-err-invalid-national-code');
    } else if (err.equalWith) {
      text = err.equalWith.message;
    } else {
      text = this.trans.instant('validation-err-unknown');
    }

    return text;
  }
}
